// extracted by mini-css-extract-plugin
export default {"innerWrapper":"FA-z","tooltipWrapper":"GA-z","icon":"HA-z","tooltip":"IA-z","content":"JA-z"};